import { createApp } from '@app/adapters/create-app'

import PinnedReports from '@app/application/report/components/pinned-reports.vue'

window.onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='reports/pinned-reports']").each(function () {
    const expectedCount = parseInt(this.dataset.pinnedCount ?? '', 10)

    createApp(PinnedReports, {
      expectedCount: Number.isNaN(expectedCount) ? undefined : expectedCount,
    }).mount(this)
  })
})
